;(function( window, document, bq ){ window.jQuery(function($) { 'use strict';

bq.deleteRelation = function(element, options) {
    this.$el = $(element);
    this.options = options;
    this._currentSupplierId = null;
    this._currentSku = null;
    this._currentExternalId = null;
};

bq.deleteRelation.DEFAULTS = {
    deleteRelationUrl: '',
    labels: {
        deleting: 'Deleting...',
        deleteRelation: 'Delete Relation',
        deletingRelation: 'Deleting relation...',
        deleteSuccess: 'Relation deleted successfully!',
        deleteFailed: 'Failed to delete relation',
        missingExternalId: 'Error: Relation external ID is missing. Cannot delete relation.',
        missingExternalIdShort: 'Error: Relation external ID is missing.'
    }
};

bq.deleteRelation.prototype = {
    init: function() {
        this._bindEvents();
        this._initFromContext();
    },

    _initFromContext: function() {
        if (window.bqOpenDeleteRelationFor) {
            this._currentSupplierId = window.bqOpenDeleteRelationFor.supplier_id;
            this._currentSku = window.bqOpenDeleteRelationFor.sku;
            this._currentExternalId = window.bqOpenDeleteRelationFor.external_id;
            this.$el.find('#bqDeleteRelation-product-name').text(
                window.bqOpenDeleteRelationFor.name || this._currentSupplierId + ' - ' + this._currentSku
            );
            this.$el.find('#bqDeleteRelation-product-sku').text(this._currentSku || '-');
        } else {
            var supplierId = this.$el.attr('data-supplier-id');
            var sku = this.$el.attr('data-sku');
            var externalId = this.$el.attr('data-external-id');
            if (supplierId && sku) {
                this._currentSupplierId = supplierId;
                this._currentSku = sku;
                this._currentExternalId = externalId;
                this.$el.find('#bqDeleteRelation-product-name').text(supplierId + ' - ' + sku);
                this.$el.find('#bqDeleteRelation-product-sku').text(sku || '-');
            }
        }

        var labels = bq.messages.recommendations;
        var $status = this.$el.find('#bqDeleteRelation-status');
        var $deleteBtn = this.$el.find('#bqDeleteRelation-delete-btn');
        var externalId = this._currentExternalId;
        if (!externalId || externalId === '' || externalId === 'null' || externalId === 'undefined') {
            $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-danger')
                .text(labels.missingExternalId).show();
            $deleteBtn.prop('disabled', true);
        } else {
            $status.hide();
            $deleteBtn.prop('disabled', false);
        }
    },

    _bindEvents: function() {
        var self = this;

        $(document).off('click.deleteRelation', '.delete-relation-modal-cancel')
            .on('click.deleteRelation', '.delete-relation-modal-cancel', function(e) {
                e.preventDefault();
                $(this).closest('.modal').modal('hide');
            });

        $(document).off('click.deleteRelation', '#bqDeleteRelation-delete-btn')
            .on('click.deleteRelation', '#bqDeleteRelation-delete-btn', function() {
                self._handleDelete();
            });

        $(document).off('hidden.bs.modal.deleteRelation')
            .on('hidden.bs.modal.deleteRelation', function(e) {
                if ($(e.target).find('.delete-relation-form-content').length) {
                    self._reset();
                }
            });

        $(document).off('deleteRelationFormInserted.deleteRelation')
            .on('deleteRelationFormInserted.deleteRelation', function() {
                setTimeout(function() { self._initFromContext(); }, 50);
            });
    },

    _handleDelete: function() {
        var self = this;
        var labels = bq.messages.recommendations;
        var $deleteBtn = this.$el.find('#bqDeleteRelation-delete-btn');
        var $status = this.$el.find('#bqDeleteRelation-status');

        if (!this._currentExternalId || this._currentExternalId === '' ||
            this._currentExternalId === 'null' || this._currentExternalId === 'undefined') {
            $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-danger')
                .text(labels.missingExternalIdShort).show();
            return;
        }

        $deleteBtn.prop('disabled', true).text(labels.deleting);
        $status.removeClass('alert-success alert-danger alert-warning').addClass('alert-info')
            .text(labels.deletingRelation).show();

        $.ajax({
            url: this.options.deleteRelationUrl,
            method: 'POST',
            contentType: 'application/json',
            data: JSON.stringify({ external_id: this._currentExternalId }),
            dataType: 'json'
        }).done(function(data) {
            if (data && data.success) {
                $status.removeClass('alert-info alert-danger alert-warning').addClass('alert-success')
                    .text(labels.deleteSuccess);
                setTimeout(function() {
                    self.$el.closest('.modal').modal('hide');
                    $(document).trigger('bqRelationDeleted');
                }, 1000);
            } else {
                var errorMsg = (data && data.error) ? data.error : labels.deleteFailed;
                $status.removeClass('alert-info alert-success alert-warning').addClass('alert-danger')
                    .text(errorMsg);
                $deleteBtn.prop('disabled', false).text(labels.deleteRelation);
            }
        }).fail(function(xhr) {
            var errorMsg = labels.deleteFailed;
            if (xhr.responseJSON && xhr.responseJSON.error) {
                errorMsg += ': ' + xhr.responseJSON.error;
            } else if (xhr.responseText) {
                try {
                    var resp = JSON.parse(xhr.responseText);
                    if (resp.error) { errorMsg += ': ' + resp.error; }
                } catch(e) {
                    errorMsg += ': ' + xhr.responseText.substring(0, 100);
                }
            }
            $status.removeClass('alert-info alert-success alert-warning').addClass('alert-danger').text(errorMsg);
            $deleteBtn.prop('disabled', false).text(labels.deleteRelation);
        });
    },

    _reset: function() {
        this.$el.find('#bqDeleteRelation-status').hide();
        this.$el.find('#bqDeleteRelation-delete-btn').prop('disabled', false)
            .text(bq.messages.recommendations.deleteRelation);
        window.bqOpenDeleteRelationFor = null;
        this._currentSupplierId = null;
        this._currentSku = null;
        this._currentExternalId = null;
    }
};

var oldDeleteRelation = $.fn.deleteRelation;
$.fn.deleteRelation = function(option) {
    return this.each(function() {
        var $this = $(this);
        var data = $this.data('bq.deleteRelation');
        var options = $.extend(true, {}, bq.deleteRelation.DEFAULTS, $this.data(), typeof option === 'object' && option);
        if (!data) { $this.data('bq.deleteRelation', (data = new bq.deleteRelation(this, options))); }
        data.init();
    });
};
$.fn.deleteRelation.Constructor = bq.deleteRelation;
$.fn.deleteRelation.noConflict = function() { $.fn.deleteRelation = oldDeleteRelation; return this; };

bq.deleteRelationInit = function() {
    $('[data-bq="delete-relation"]:not([data-initialized])').each(function() {
        $(this).deleteRelation($(this).data());
    });
};
bq.init.push(bq.deleteRelationInit);
bq.deleteRelationInit();

});}( window, document, bq));
